export default class AuthZeroRole {
    constructor(data){
        this.id = data.id,
        this.name = data.name,
        this.description = data.description ?? "No Description Available"
    }
}